import type { NormalizeOAS, OASRequestParams } from 'fets';
import type { ApiClient } from '../fetsClient';
import type openapi from '../openapi';

type O = NormalizeOAS<typeof openapi>;
type RequestParams = OASRequestParams<O, '/api/export-project/tracking-settings', 'post'>;

type Params = {
  projectId: number;
  mandatoryItemIds: number[];
};

export const updateTrackingSettingsFactory = (apiClient: ApiClient) => {
  const updateTrackingSettings = async (variables: Params) => {
    const requestBody = mapInputToRequestBody(variables);
    await apiClient['/api/export-project/tracking-settings'].post(requestBody);
  };

  const mapInputToRequestBody = (input: Params): RequestParams => {
    return {
      json: {
        projectId: input.projectId,
        mandatoryItemIds: input.mandatoryItemIds,
      },
    };
  };

  return updateTrackingSettings;
};
